import member from './modules/member';
import billing from './modules/billing';
import payment from './modules/payment';
import utils from './utils';
import communication from './modules/communication';
import maintenance from './modules/maintenance';
import wallet from './modules/wallet';
import history from './modules/history';
import accessToken from './modules/accessToken';

const API = {
  member: member(),
  billing: billing(),
  payment: payment(),
  communication: communication(),
  maintenance: maintenance(),
  wallet: wallet(),
  history: history(),
  accessToken: accessToken(),
  utils: utils,
};

export default API;
